import React from 'react';
import { Col, Row } from 'reactstrap';
import HighlightText from './HighlightText';
import { renderHTMLContent } from '../../common/function';

function ViewQuestion(props) {
  const {
    question,
    id,
    children,
    correctChoice,
    showAnswer,
    selectedChoice,
    setAnswer,
    selectedChoiceClassName = 'clicked_box',
    correctChoiceClassName = 'success',
    incorrectChoiceClassName = 'failure',
    strikeText,
    strikeThroughArr = [],
    params = {},
    shouldHighLight = false,
  } = props;
  const choices = [];
  for (const [key, value] of Object.entries(props)) {
    if (key.startsWith('choice')) {
      choices.push({ [key]: value });
    }
  }
  return (
    <Row>
      <Col>
        {shouldHighLight ? (
          <HighlightText params={params} content={question} />
        ) : (
            renderHTMLContent(
              question,
              "div",
              "margin_bottom_40 view_questionhtml bg_blue",
              { contentEditable: false }
            )
        )}
      </Col>

      {choices.map((element, index) => {
        return (
          <div
            className={`col-sm-12`}
            id={Object.keys(element)}
            key={`${Object.keys(element)}/${id}`}
            onClick={() => !showAnswer && setAnswer(Object.keys(element))}
            onContextMenu={(event) => strikeText(event, Object.keys(element))}
            disabled={showAnswer}
          >
            <div
              className={`answer_box ${
                strikeThroughArr.includes(Object.keys(element)[0]) ? 'strikethrough' : ''
              } ${
                !showAnswer && selectedChoice === Object.keys(element)[0]
                  ? selectedChoiceClassName
                  : ''
              } ${
                showAnswer && Object.keys(element)[0] === correctChoice
                  ? correctChoiceClassName
                  : ''
              }
                ${
                  showAnswer &&
                  selectedChoice === Object.keys(element)[0] &&
                  selectedChoice !== correctChoice
                    ? incorrectChoiceClassName
                    : ''
                }
                `}
            >
              <div className='answer_count'>{String.fromCharCode(index + 65)}</div>
              <p className='ans_box_text'>
                {renderHTMLContent(
                  element[Object.keys(element)],
                  "span",
                  "",
                  { contentEditable: false }
                )}
              </p>
            </div>
          </div>
        );
      })}

      {children}
    </Row>
  );
}

export default ViewQuestion;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/ViewQuestion.jsx